var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from '../../Application';
import { Constants, Order } from '../../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var ModalVisibilityManagementBehavior = (function () {
    function ModalVisibilityManagementBehavior(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject || Inject.Instance;
        this.eventAggregator = this.inject.resolve(Constants.EventAggregator);
    }
    ModalVisibilityManagementBehavior.prototype.apply = function (model, root) {
        var _this = this;
        if (model.IsModalView) {
            model.onPropertyChange = function (property, oldValue, newValue) {
                if (property === 'visible' && oldValue !== newValue) {
                    if (newValue === true) {
                        _this.eventAggregator.publish('navigateToView', model);
                    }
                    else {
                        _this.eventAggregator.publish('disposeView', model);
                    }
                }
            };
        }
    };
    Object.defineProperty(ModalVisibilityManagementBehavior.prototype, "Order", {
        get: function () {
            return Order.POST;
        },
        enumerable: false,
        configurable: true
    });
    ModalVisibilityManagementBehavior = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], ModalVisibilityManagementBehavior);
    return ModalVisibilityManagementBehavior;
}());
export { ModalVisibilityManagementBehavior };
